/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface EnrollmentScheduleGroupControllerDelete$Params {
  groupId: string;
}

export function enrollmentScheduleGroupControllerDelete(http: HttpClient, rootUrl: string, params: EnrollmentScheduleGroupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleGroupControllerDelete.PATH, 'delete');
  if (params) {
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

enrollmentScheduleGroupControllerDelete.PATH = '/api/enrollment-schedule-group';
